import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LoginForm } from '../../components/admin/LoginForm';
import { NuevaPasswordForm } from '../../components/admin/NuevaPasswordForm';
import { useLogin, useResponderNuevaPassword } from '../../hooks/useAuth';
import { useAuthContext } from '../../context/AuthProvider';
import { ApiError } from '../../api/apiClient';
import { DesafioNuevaPassword } from '../../types/identidad';

export function LoginPage() {
  const login = useLogin();
  const responderNuevaPassword = useResponderNuevaPassword();
  const { login: guardarSesionEnContexto } = useAuthContext();
  const navigate = useNavigate();
  const [error, setError] = useState<string>();
  const [desafio, setDesafio] = useState<DesafioNuevaPassword>();

  const enviarLogin = (datos: { usuario: string; password: string }) => {
    setError(undefined);
    login.mutate(datos, {
      onSuccess: (resultado) => {
        if ('challenge' in resultado) {
          setDesafio(resultado);
          return;
        }
        guardarSesionEnContexto(resultado);
        navigate('/admin');
      },
      onError: (err) => setError(err instanceof ApiError ? err.message : 'No se pudo iniciar sesión'),
    });
  };

  const enviarNuevaPassword = (nuevaPassword: string) => {
    if (!desafio) return;
    setError(undefined);
    responderNuevaPassword.mutate(
      { usuario: desafio.usuario, session: desafio.session, nuevaPassword },
      {
        onSuccess: (sesion) => {
          guardarSesionEnContexto(sesion);
          navigate('/admin');
        },
        onError: (err) => setError(err instanceof ApiError ? err.message : 'No se pudo guardar la nueva contraseña'),
      },
    );
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-admin-bg to-[oklch(92%_0.01_80)] px-4">
      <div className="w-full max-w-[400px] flex flex-col gap-6 bg-white border border-admin-border rounded-2xl p-8 sm:p-11 shadow-xl">
        <div className="flex flex-col items-center gap-1.5">
          <div className="font-display text-[30px] font-bold text-wood">Santtesanía</div>
          <div className="text-xs font-semibold uppercase tracking-wide text-admin-ink-muted">
            Panel Administrativo
          </div>
        </div>

        {desafio ? (
          <NuevaPasswordForm
            onSubmit={enviarNuevaPassword}
            enviando={responderNuevaPassword.isPending}
            error={error}
          />
        ) : (
          <>
            <LoginForm onSubmit={enviarLogin} enviando={login.isPending} error={error} />
            <Link to="/admin/olvide-password" className="text-center text-xs font-semibold text-terracotta">
              ¿Olvidaste tu contraseña?
            </Link>
          </>
        )}

        <div className="text-center text-xs text-admin-ink-muted">
          Acceso exclusivo para administradores y empleados
        </div>
      </div>
    </div>
  );
}
